<div class="flex flex-row gap-4 justify-between items-start">
  <div class="flex flex-row gap-4 items-center">
    <div class="bg-surface-tertiary rounded w-20 h-20">&nbsp;</div>
    <div class="flex flex-col">
      <div class="flex items-center gap-1">
        <h6 class="soft-overline mb-0! p-0">{{ product()?.key }}</h6>
        @if ($safeNavigationMigration(product()?.status) | isDefinedNotEmpty) {
          <div class="flex text-wrap! min-height-75 max-height-70">
            <soft-chip [customClass]="statusColor($safeNavigationMigration(product()?.status?.type))">
              {{ product()?.status?.description }}
            </soft-chip>
          </div>
        }
      </div>
      <h6 class="text-base font-semibold">{{ product()?.language?.name }}</h6>
      @if ($safeNavigationMigration(product()?.language?.description1) | isDefinedNotEmpty) {
        <h6 class="text-sm text-light">{{ product()?.language?.description1 }}</h6>
      }
      @if ($safeNavigationMigration(product()?.language?.description2) | isDefinedNotEmpty) {
        <h6 class="text-sm text-light">{{ product()?.language?.description2 }}</h6>
      }
      @if ($safeNavigationMigration(product()?.language?.description3) | isDefinedNotEmpty) {
        <h6 class="text-sm text-light">{{ product()?.language?.description3 }}</h6>
      }
      @if ($safeNavigationMigration(product()?.language?.description4) | isDefinedNotEmpty) {
        <h6 class="text-sm text-light">{{ product()?.language?.description4 }}</h6>
      }
      @if ($safeNavigationMigration(product()?.language?.description5) | isDefinedNotEmpty) {
        <h6 class="text-sm text-light">{{ product()?.language?.description5 }}</h6>
      }
    </div>
  </div>
</div>
